import "./document.css"

import Header from "../../components/01_header/header";
import Footer from "../../components/02_footer/footer";

export default function TermsConditions() {
    return (
        <div>
            <Header />
            <div className="documentation">
                <h1>Terms and Conditions – AI Tutor Labs</h1>

                <p>
                    Welcome to AI Tutor Labs. These Terms and Conditions (“Terms”) govern
                    your use of the AI Tutor Labs mobile application (“App”) available on
                    Android and iOS platforms.
                </p>

                <p>
                    By downloading, registering, or using the App, you agree to be bound by
                    these Terms. If you do not agree, please do not use the App.
                </p>

                <h2>1. Acceptance of Terms</h2>
                <p>
                    By creating an account or using AI Tutor Labs, you confirm that you:
                </p>
                <ul>
                    <li>Are legally permitted to use the App</li>
                    <li>Have read, understood, and agreed to these Terms</li>
                    <li>Will comply with all applicable laws and regulations</li>
                </ul>

                <h2>2. Description of Service</h2>
                <p>AI Tutor Labs is an AI-powered educational platform that provides:</p>
                <ul>
                    <li>AI-based tutoring and learning assistance</li>
                    <li>Educational content and responses</li>
                    <li>Personalized learning support</li>
                </ul>
                <p>The App is intended for educational purposes only.</p>

                <h2>3. User Accounts &amp; Registration</h2>
                <p>To access core features, users must register using:</p>
                <ul>
                    <li>Email &amp; password, or</li>
                    <li>Google Sign-In</li>
                </ul>
                <p>You agree to:</p>
                <ul>
                    <li>Provide accurate and up-to-date information</li>
                    <li>Keep your login credentials secure</li>
                    <li>Accept responsibility for all activities under your account</li>
                </ul>
                <p>
                    AI Tutor Labs is not responsible for unauthorized account access due to
                    user negligence.
                </p>

                <h2>4. Acceptable Use</h2>
                <p>You agree not to:</p>
                <ul>
                    <li>Use the App for illegal or harmful activities</li>
                    <li>Submit abusive, offensive, or inappropriate content</li>
                    <li>Attempt to reverse engineer or misuse the AI system</li>
                    <li>Interfere with app security or performance</li>
                </ul>
                <p>
                    Violation of these rules may result in account suspension or
                    termination.
                </p>

                <h2>5. AI-Generated Content Disclaimer</h2>
                <ul>
                    <li>
                        AI responses are generated automatically and may not always be
                        accurate
                    </li>
                    <li>
                        Content should not be treated as professional, medical, legal, or
                        financial advice
                    </li>
                    <li>Users are responsible for how they use the information provided</li>
                    <li>
                        AI Tutor Labs is not liable for decisions made based on AI-generated
                        responses.
                    </li>
                </ul>

                <h2>6. Intellectual Property</h2>
                <p>
                    All content, design, logos, code, and AI systems in the App are the
                    intellectual property of AI Tutor Labs.
                </p>
                <p>Users may not:</p>
                <ul>
                    <li>Copy, distribute, or resell any part of the App</li>
                    <li>Use content for commercial purposes without permission</li>
                </ul>

                <h2>7. User Content</h2>
                <p>Users may input questions or educational prompts.</p>
                <p>By submitting content, you:</p>
                <ul>
                    <li>
                        Grant AI Tutor Labs permission to process it for providing services
                    </li>
                    <li>Confirm that the content does not violate any laws or rights</li>
                </ul>
                <p>We do not claim ownership of your input content.</p>

                <h2>8. Privacy</h2>
                <p>
                    Your use of the App is also governed by our Privacy Policy, which
                    explains how we collect and protect your data.
                </p>
                <p>Please review the Privacy Policy carefully before using the App.</p>

                <h2>9. Children’s Use</h2>
                <p>AI Tutor Labs is designed for educational use.</p>
                <ul>
                    <li>
                        Users under the age of 13 should use the App with parental consent
                    </li>
                    <li>
                        We do not knowingly allow misuse by minors in violation of applicable
                        laws
                    </li>
                </ul>

                <h2>10. Account Termination</h2>
                <p>We reserve the right to:</p>
                <ul>
                    <li>Suspend or terminate accounts that violate these Terms</li>
                    <li>Remove content that breaches policies</li>
                </ul>
                <p>Users may request account deletion at any time.</p>

                <h2>11. Limitation of Liability</h2>
                <p>To the maximum extent permitted by law:</p>
                <ul>
                    <li>
                        AI Tutor Labs is not liable for indirect or consequential damages
                    </li>
                    <li>Use of the App is at your own risk</li>
                    <li>The App is provided on an “as is” and “as available” basis</li>
                </ul>

                <h2>12. Changes to Terms</h2>
                <p>We may update these Terms from time to time.</p>
                <p>
                    Continued use of the App after changes means you accept the revised
                    Terms.
                </p>

                <h2>13. Governing Law</h2>
                <p>
                    These Terms shall be governed by and interpreted in accordance with the
                    laws applicable in your jurisdiction.
                </p>

                <h2>14. Contact Information</h2>
                <p>For questions or concerns regarding these Terms, contact:</p>
                <p>
                    <strong>AI Tutor Labs</strong><br />
                    Email:
                    <a href="mailto:admin@aitutorlabs.co.in">admin@aitutorlabs.co.in</a>
                </p>
            </div>
            <Footer />
        </div>
    );
}